/**
 * Block JS Modules - Master entry point
 *
 * Import block-specific JS modules here as they are migrated.
 * Each module exports an init() function that self-selects its DOM elements.
 * Vite builds this into dist/js/blocks.js
 */

// ==========================================================================
// Block imports (uncomment as blocks are migrated)
// ==========================================================================

// import { init as productCards } from './product-cards.js';
import { init as annualReports } from './annual-reports.js';
import { init as threeColumnCards } from './three-column-cards.js';
import { init as helperCardsGeneral } from './helper-cards-general.js';
import { init as businessEssential } from './business-essential.js';
import { init as newDoubleFeatureSlider } from './new-double-feature-slider.js';
import { init as newHeroGeneral } from './new-hero-general.js';
import { init as newProparentBottom } from './new-proparent-bottom.js';
import { init as servicesGeneral } from './services-general.js';
import { init as simpleMap } from './simple-map.js';
import { init as staff } from './staff.js';
import { init as slidingCalculator } from './sliding-calculator.js';
import { init as referenceCards } from './reference-cards.js';
import { init as howToUseCard } from './how-to-use-card.js';
import { init as newTriggerModal } from './new-triggermodal.js';
// Site-wide UI (not blocks, but this bundle loads on every page)
import { init as videoModal } from './video-modal.js';
import { init as welcomeModal } from './welcome-modal.js';
import { initCookieSettingsLinks } from './cookie-consent.js';
import { init as twoColumnImageTextGeneral } from './two-column-image-text-general.js';
import './tables-pr.js';

// ==========================================================================
// Initialize all block modules
// ==========================================================================

function initBlocks() {
    // productCards();
    annualReports();
    threeColumnCards();
    helperCardsGeneral();
    businessEssential();
    newDoubleFeatureSlider();
    newHeroGeneral();
    newProparentBottom();
    servicesGeneral();
    simpleMap();
    staff();
    slidingCalculator();
    referenceCards();
    howToUseCard();
    newTriggerModal();
    videoModal();
    welcomeModal();
    initCookieSettingsLinks();
    twoColumnImageTextGeneral();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlocks);
} else {
    initBlocks();
}
